import { useLiveData, useService, useServices } from '@toeverything/infra';

import { AppSidebarService } from '../../services/app-sidebar';
import { navHeaderLogoStyle, navHeaderStyle } from '../index.css';
import { SidebarSwitch } from './sidebar-switch';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { WorkbenchService } from '@affine/core/modules/workbench';

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);
  const { workbenchService, workspaceService } = useServices({
    WorkbenchService,
    WorkspaceService,
  });
  const workbench = workbenchService.workbench;
  const handleOpenHome = () => {
    workbench.openDoc('home');
    workspaceService.workspace.eventBus.emit(
      { id: 'chat.created', _type: 'chat.created' },
      {}
    );
  };
  return (
    <div className={navHeaderStyle} data-open={open}>
      <img
        onClick={handleOpenHome}
        className={navHeaderLogoStyle}
        src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/46A3850C-44C0-440A-AD80-37CA8009C679.png"
      />
      <SidebarSwitch show={open} />
    </div>
  );
};

export * from './sidebar-switch';
